import {Component, OnInit, Input, ChangeDetectorRef} from '@angular/core';
import {NavController, ModalController} from '@ionic/angular';
import {ActivatedRoute} from '@angular/router';
import {Router} from '@angular/router';
import {DataStore} from '@aws-amplify/datastore';
import {Team, User, Bonus, Contract, BonusType} from '../../../models';
import {SessionService} from '../../services/session.service';
import {CareerController} from '../../models/career-controller';
import {BonusServiceService} from "../../services/bonus-service.service";

@Component({
    selector: 'app-user-bonuses',
    templateUrl: './user-bonuses.component.html',
    styleUrls: ['./user-bonuses.component.scss'],
})
export class UserBonusesComponent implements OnInit {
    @Input() owner: any;
    @Input() style;// "temporal" | "category";

    currentPanel = 'overview';
    period = 'mese';
    careerSteps = [];
    paymentsByMese = [];
    paymentsByTrimestre = [];
    paymentsByAnno = [];
    bonusByPeriod = 500;
    contra: Contract;
    bb: Bonus;
    careerController: CareerController;

    teamBonus = 0.5;
    careerTitle: string = 'Caricamento...';
    showCareerPanel = false;
    showMarketingFeePanel = false;
    showManagerFeePanel = false;
    showTeamBonusPanel = false;
    showRevenueFeePanel = false;
    showSponsorFeePanel = false;
    showLeaderBonusPanel = false;
    showAmbassadorBonusPanel = false;
    showCompanyBonusPanel = false;
    showDirectorBonusPanel = false;
    showQuarterPanel = false;

    value: string;
    selectedYear: any;
    selectedMonth: any;
    monthes = [];
    years = [];
    bonusType = BonusType;


    constructor(
        private route: ActivatedRoute,
        public router: Router,
        public sessionService: SessionService,
        private navController: NavController,
        private modalController: ModalController,
        public cd: ChangeDetectorRef,
        public bonusService: BonusServiceService,
    ) {

    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');

        let scrollerEl = document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].querySelector('.content-scroller');
        scrollerEl.addEventListener('scroll', function (e) {
            const lastKnownScrollPosition = e['target']['scrollTop'];

            const avatar = document.querySelectorAll('.main-header')[document.querySelectorAll('.main-header').length - 1].querySelector('.header-avatar');
            const content = document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].querySelector('.content');
            if (window.innerHeight - content.clientHeight < 0) {
                if (lastKnownScrollPosition >= 1) {
                    avatar.classList.add('resized');
                } else {
                    avatar.classList.remove('resized');
                }
            }
        });
    }

    async ngOnInit() {
        this.cd.detach();
        setInterval(() => {
            this.cd.reattach();
            this.cd.detectChanges();
            this.cd.detach();

        }, 1000);

        const user = await DataStore.query(User, this.owner.id);

        await this.bonusService.init(user.id);


        this.careerController = new CareerController(user);
        this.careerController.teamBonus3$.subscribe(value => this.teamBonus = value);
        this.careerController.careerTitle$.subscribe(value => this.careerTitle = value);

        this.careerSteps.push({
            role: 'Senior Advisor',
            percent: 88,
        });
        this.careerSteps.push({
            role: 'Leader Advisor',
            percent: 10,
        });

        this.paymentsByMese = this.paymentsByTrimestre = this.paymentsByAnno = await DataStore.query(
            Bonus,
        );

        // this.paymentsByMese.push({ source: 'Contract n.1', url: 'sdfsd', amount: 900, date: '31/12/2021', status: 'pagato' });
        // this.paymentsByMese.push({ source: 'Contract n.2', url: 'dsfsd', amount: 1900, date: '21/12/2021', status: 'nonpagato' });

        // this.paymentsByTrimestre.push({ source: 'Contract n.3', url: '', amount: 900, date: '31/12/2021', status: 'pagato' });
        // this.paymentsByTrimestre.push({ source: 'Contract n.4', url: '', amount: 1900, date: '21/12/2021', status: 'nonpagato' });

        // this.paymentsByAnno.push({ source: 'Contract n.5', url: '', amount: 900, date: '31/12/2021', status: 'pagato' });
        // this.paymentsByAnno.push({ source: 'Contract n.6', url: '', amount: 1900, date: '21/12/2021', status: 'nonpagato' });
    }

    openContract(id) {
        this.router.navigate(['/contract', id]);
    }

    back() {
        this.navController.back();
    }

    changeYear($event: any) {

    }

    changeMonth($event: Event) {

    }
}
